<ng-container [formGroup]="membershipDetailForm">
  <div class="input-group">
    <mat-form-field
      [color]="'accent'"
      [appearance]="matFormFieldAppearance"
      [hideRequiredMarker]="true">
      <mat-label>{{
        'transfer_v2.checkout.label.membership_number'
          | translate
            : {
                loyaltyProgramShortName: loyaltyProgram.shortName
              }
      }}</mat-label>
      <input
        class="link-account-membership-number"
        matInput
        type="text"
        formControlName="membershipNumber"
        [required]="true" />
      <mat-hint
        class="validating-membership-number"
        *ngIf="membershipNumberValidationPending()">
        {{ 'transfer_v2.checkout.hint.validating' | translate }}
      </mat-hint>
      <mat-error
        class="invalid-membership-number"
        *ngIf="isMembershipNumberInvalid()"
        [attr.aria-live]="'polite'">
        {{ 'transfer_v2.checkout.error.invalid_membership_number' | translate }}
      </mat-error>
      <mat-error
        class="required-membership-number"
        *ngIf="isMembershipNumberEmpty()"
        [attr.aria-live]="'polite'">
        {{
          'transfer_v2.checkout.error.required_membership_number' | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label>{{
        'transfer_v2.checkout.label.first_name' | translate
      }}</mat-label>
      <input
        class="link-account-first-name"
        matInput
        type="text"
        formControlName="firstName" />
      <mat-error class="required-first-name" *ngIf="isFirstNameEmpty()">
        {{ 'transfer_v2.checkout.error.required_first_name' | translate }}
      </mat-error>
      <mat-error class="invalid-first-name" *ngIf="firstNameIsInvalid()">
        {{ 'transfer_v2.checkout.error.invalid_first_name' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label>{{
        'transfer_v2.checkout.label.last_name' | translate
      }}</mat-label>
      <input
        class="link-account-last-name"
        matInput
        type="text"
        formControlName="lastName" />
      <mat-error class="required-last-name" *ngIf="isLastNameEmpty()">
        {{ 'transfer_v2.checkout.error.required_last_name' | translate }}
      </mat-error>
      <mat-error class="invalid-last-name" *ngIf="lastNameIsInvalid()">
        {{ 'transfer_v2.checkout.error.invalid_last_name' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group" *ngIf="showDobField">
    <rd-shared-date-picker
      formControlName="dateOfBirth"
      [customDateValidationFn]="dateValidatorFn">
      <mat-error class="custom-error" *ngIf="dateOfBirthHasFutureDate()">
        {{ 'shared.datepicker.future_date' | translate }}
      </mat-error>
      <mat-error class="custom-error" *ngIf="dateOfBirthIsBlank()">
        {{ 'shared.datepicker.invalid_date' | translate }}
      </mat-error>
    </rd-shared-date-picker>
  </div>
</ng-container>
